import { RegisterButton } from '@components/log_in/RegisterButton'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_nolayout/_auth/register')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
        <div className={'basis-1/3 block content-center'}>
            <RegisterButton />
        </div>
  )
}
